import { useEffect, useState } from "react";
import { Modal, Upload, Button, message, Form, Input, Table, Select } from "antd";
import { useParams } from "react-router-dom";
import {
  ArrowRightOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import HamburgerNavbar from "../../Components/HamburgerNavbar";
import Footer from "../../Components/Footer";
import apiInstance from "../../services/axiosInstance";

const {Option} = Select

const BulkCertificates = () => {
  let { id } = useParams();
  const [batchName, setBatchName] = useState("");
  const [csvFile, setCsvFile] = useState("");
  const [emailStatus, setEmailStatus] = useState([]);
  const [loadingEmailStatus, setLoadingEmailStatus] = useState(false);
  let [loading, setLoading] = useState(false)
  const [emailTempaltes, setEmailTempates] = useState([]);
  const [selectedEmailTemplate, setSelectedEmailTemplate] = useState(null);
  
  let pollInterval;

  const authDetails = JSON.parse(localStorage.getItem("authDetails"));
  let token = authDetails?.token;

  useEffect(() => {
    const fetchEmailTemplates = async () => {
      try {
        const response = await apiInstance.get("/emailTemplates");
        setEmailTempates(response.data)
      } catch (error) {
        console.error("Error fetching email templates : ", error)
      }
    }

    fetchEmailTemplates()
  }, [])

  console.log("Templates : ", emailTempaltes.templates)


  const handleBatchName = (e) => {
    const { value } = e.target;
    setBatchName(value);
  };

  const handleCsvFile = (e) => {
    setCsvFile(e.target.files[0]);
  };

  const handleUploadCSV = async (e) => {
    const formData = new FormData();
    formData.append("csv", csvFile);
    // formData.append("id", id);
    formData.append("batch", batchName);
    formData.append("emailTemplate", selectedEmailTemplate)
    message.success("Your mails are being sent")
    setLoading(true)
    try {
      const response = await apiInstance.post(`/batchcertificate/certificate/batch/${id}`, formData);
      const data = await response.data;
      // const data = await response.json();
      message.success("CSV file uploaded successfully!");
      setLoading(false)
      setEmailStatus(data.message);
      message.success("Mails sent successfully successfully!");
    } catch (error) {
      setLoading(false)
      console.error("Error uploading CSV file:", error);
      message.error("Error uploading CSV file!");
    }
  };

  const handleEmailTemplates = (value) => setSelectedEmailTemplate(value)

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      width: "30%",
      align: "center",
    },
    {
      title: "Email",
      dataIndex: "email",
      width: "40%",
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "result",
      width: "30%",
      align: "center",
      render: (result) => {
        if (loadingEmailStatus) {
          // Loading state when fetching email status
          return <LoadingOutlined />;
        } else {
          if (result === null) {
            // Email is in progress
            return <LoadingOutlined />;
          } else {
            if (result === "success") {
              // Email sent successfully
              return <CheckCircleOutlined style={{ color: "green", fontSize: "18px" }} />;
            } else {
              // Email failed
              return <CloseCircleOutlined style={{ color: "red", fontSize: "18px" }} />;
            }
          }
        }
      },
    },
  ];
  const data = [];
  for (let i = 0; i < 1000; i++) {
    let status = Math.random() < 0.5 ? true : false;
    data.push({
      key: i,
      name: `Pankaj Kumar Ram ${i + 1}`,
      email: `pankajkr${i + 1}@gmail.com`,
      status: status,
    });
  }

  return (
    <>
      <HamburgerNavbar />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "30px",
          // minHeight: "68vh",
        }}
      >
        <Form layout="inline" onFinish={handleUploadCSV}>
          <h3 style={{ marginTop: "5px" }}>
            Upload CSV File <ArrowRightOutlined />{" "}
          </h3>
          <Form.Item
            name="batch"
            rules={[
              {
                required: true,
                message: "Please enter batch name",
              },
              {
                whitespace: true,
                message: "Batch name cannot be empty spaces",
              },
              // { min: 4, message: "name should be greater than 4 letters" },
            ]}
          >
            <Input
              className="inputBox"
              placeholder="Batch Name"
              id="image-upload"
              type="text"
              onChange={handleBatchName}
            />
          </Form.Item>
          <Form.Item
            name="image"
            rules={[
              {
                required: true,
                message: "Please select file from your computer",
              },
            ]}
          >
            <Input
              className="inputBox"
              id="image-upload"
              type="file"
              accept=".csv"
              onChange={handleCsvFile}
            />
          </Form.Item>
          <Form.Item
          name="emailTemplate"
          rules={[
            {
              required: true,
              message: "Please select a email template",
            },
          ]}
          >
            <Select
            showSearch
            style={{ width: 200 }}
            placeholder="Select email template"
            optionFilterProp="children"
            onChange={handleEmailTemplates}
            value={selectedEmailTemplate}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {emailTempaltes && emailTempaltes?.templates?.map(template => (
              <Option key={template._id} value={template.fileName}>{template.name}</Option>
            ))}
          </Select>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Generate Certificates
            </Button>
          </Form.Item>
        </Form>
      </div>
        
      <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
        
        {loading?<LoadingOutlined/>:<Table
          columns={columns}
          // dataSource={data}
          dataSource={emailStatus.map((row, index) => ({ ...row, key: index }))}
          style={{ width: "50%" }}
          pagination={{
            pageSize: 50,
          }}
          scroll={{
            y: 415,
          }}
        />}
      </div>
    </>
  );
};

export default BulkCertificates;
